import React, { createContext, useEffect, useState, useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Content from '../../../template/Content';
import Header from '../../../template/Header';
import Navigator from '../../../template/Navigator';
import ConnectionBanner from '../ConnectionBanner';
import IconButton from '@mui/material/IconButton';
import theme from '../../../template/theme'; // ייבוא הקובץ החדש
import { GlobalContext } from '../../../../App';
import { createFetchDataServer, getTableData } from '../../../../database/fetchData';

const TemplateContext = createContext();
const DataContext = createContext();

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        MBE
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}

const Graves = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const [currentTab, setCurrentTab] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [totalWidthContainer, setTotalWidthContainer] = useState(1400);
  const [drawerWidth, setDrawerWidth] = useState(256);
  const [isDrawerOpen, setIsDrawerOpen] = useState(true); // מצב פתוח/סגור של תפריט הצד

  const { token, setBreadcrumbs, setTitle } = useContext(GlobalContext);

  const [contextCemeteries, setContextCemeteries] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextBlocks, setContextBlocks] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextPlots, setContextPlots] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextRows, setContextRows] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextAreaGraves, setContextAreaGraves] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextGraves, setContextGraves] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextCustomers, setContextCustomers] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextPurchases, setContextPurchases] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextBurials, setContextBurials] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextCountries, setContextCountries] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextCities, setContextCities] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextPayments, setContextPayments] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextSignatures, setContextSignatures] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextPurchasesOld, setContextPurchasesOld] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [contextResidencies, setContextResidencies] = useState([]); // שמירת נתונים שהתקבלו מהשרת

  const varibleTemplate = {
    currentTab,
    setCurrentTab,
    searchText,
    setSearchText,
    selectedFilters,
    setSelectedFilters,
    totalWidthContainer,
    drawerWidth,
    totalWidthContainer,
    setTotalWidthContainer,
  };

  const dataContextValue = {
    contextCemeteries,
    setContextCemeteries,
    contextBlocks,
    setContextBlocks,
    contextPlots,
    setContextPlots,
    contextRows,
    setContextRows,
    contextAreaGraves,
    setContextAreaGraves,
    contextGraves,
    setContextGraves,
    contextCustomers,
    setContextCustomers,
    contextPurchases,
    setContextPurchases,
    contextBurials,
    setContextBurials,
    contextCountries,
    setContextCountries,
    contextCities,
    setContextCities,
    contextPayments,
    setContextPayments,
    contextSignatures,
    setContextSignatures,
    contextPurchasesOld,
    setContextPurchasesOld,
    contextResidencies, 
    setContextResidencies,
  };

  const fetchDataServer = createFetchDataServer(dataContextValue);

  useEffect(() => {
    console.log('טעינה');
    
    if (!navigator.onLine) {
      // localStorage.setItem('connection', JSON.stringify({ msg: 'אין חיבור לאינטרנט', active: true }))
    } else {
      async function loadTableData() {
        const localTempData = await getTableData('myDatabase', 'myStore');
        if (localTempData) {
          const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
          const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
          const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
          const dataRows = localTempData.find((item) => item.name === 'dataRows');
          const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
          const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
          const dataCustomers = localTempData.find((item) => item.name === 'dataCustomers');
          const dataPurchases = localTempData.find((item) => item.name === 'dataPurchases');
          const dataBurials = localTempData.find((item) => item.name === 'dataBurials');
          const dataCountries = localTempData.find((item) => item.name === 'dataCountries');
          const dataCities = localTempData.find((item) => item.name === 'dataCities');
          const dataPayments = localTempData.find((item) => item.name === 'dataPayments');
          const dataSignatures = localTempData.find((item) => item.name === 'dataSignatures');
          const dataPurchasesOld = localTempData.find((item) => item.name === 'dataPurchasesOld');
          const dataResidencies = localTempData.find((item) => item.name === 'dataResidencies');

          dataCemeteries && setContextCemeteries(dataCemeteries.value);
          dataBlocks && setContextBlocks(dataBlocks.value);
          dataPlots && setContextPlots(dataPlots.value);
          dataRows && setContextRows(dataRows.value);
          dataAreaGraves && setContextAreaGraves(dataAreaGraves.value);
          dataGraves && setContextGraves(dataGraves.value);
          dataCustomers && setContextCustomers(dataCustomers.value);
          dataPurchases && setContextPurchases(dataPurchases.value);
          dataBurials && setContextBurials(dataBurials.value);
          dataCountries && setContextCountries(dataCountries.value);
          dataCities && setContextCities(dataCities.value);
          dataPayments && setContextPayments(dataPayments.value);
          dataSignatures && setContextSignatures(dataSignatures.value);
          dataPurchasesOld && setContextPurchasesOld(dataPurchasesOld.value);
          dataResidencies && setContextResidencies(dataResidencies.value);
        }

        fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'graves', 'customers', 'purchases', 'burials', 'countries', 'cities', 'payments', 'signatures', 'purchasesOld', 'residencies'], token, 9000);
      }
      loadTableData();
    }
  }, [navigator.onLine]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerOpenClose = () => {
    setIsDrawerOpen(!isDrawerOpen); // שינוי מצב פתוח/סגור
  };

  return (
    <TemplateContext.Provider value={varibleTemplate}>
      <DataContext.Provider value={dataContextValue}>
        <ThemeProvider theme={theme}>
          <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <CssBaseline />
            {currentTab === 0 && (
              <Box component="nav" sx={{ width: { sm: isDrawerOpen ? drawerWidth : 0 }, flexShrink: { sm: 0 } }}>
                {isSmUp && isDrawerOpen ? null : <Navigator PaperProps={{ style: { width: drawerWidth } }} variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} />}
                <Navigator
                  PaperProps={{ style: { width: isDrawerOpen ? drawerWidth : 0 } }} // שינוי הרוחב של ה-Navigator עצמו
                  sx={{ display: { sm: 'block', xs: 'none' }, transition: 'width 0.3s ease' }}
                />
                <IconButton
                  onClick={handleDrawerOpenClose}
                  sx={{
                    position: 'fixed', // מיקום קבוע יחסית למסך
                    top: '50%', // אמצע הגובה של המסך
                    left: isDrawerOpen ? `${drawerWidth + 2}px` : '2px', // מיקום אופקי משתנה לפי מצב התפריט
                    transform: 'translateY(-50%)',
                    zIndex: 1200,
                    width: '16px',
                    height: '140px',
                    backgroundColor: 'white',
                    borderRadius: '15px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    '&:hover': {
                      backgroundColor: 'white'
                    },
                    '&::before': {
                      content: "''",
                      width: '2px',
                      height: '70px',
                      backgroundColor: '#333',
                      borderRadius: '1px',
                      position: 'absolute',
                      top: 'calc(50% - 35px)',
                      left: 'calc(50% - 4.5px)'
                    },
                    '&::after': {
                      content: '""',
                      width: '2px',
                      height: '70px',
                      backgroundColor: '#333',
                      borderRadius: '1px',
                      position: 'absolute',
                      top: 'calc(50% - 35px)',
                      right: 'calc(50% - 4.5px)'
                    }
                  }}></IconButton>
              </Box>
            )}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Header onDrawerToggle={handleDrawerToggle} />
              <Box
                component="main"
                sx={{
                  flex: 1,
                  py: 6,
                  px: 4,
                  backgroundColor: '#f2f2f2',
                  backgroundImage: `url("https://www.transparenttextures.com/patterns/asfalt-dark.png")`
                }}>
                <Content />
              </Box>
              <Box component="footer" sx={{ p: 2, bgcolor: '#eaeff1' }}>
                <Copyright />
                <ConnectionBanner />
              </Box>
            </Box>
          </Box>
          <ConnectionBanner />
        </ThemeProvider>
      </DataContext.Provider>
    </TemplateContext.Provider>
  );
};

export default Graves;
export { TemplateContext, DataContext };
